import { connect } from "react-redux"

import BulkActionsCustomField from "app/static/frontend/search-new/components/BulkActions/actions/BulkActionsCustomField"

import { bulkActionsCustomFieldConnection } from "shared/forms/BulkActions/selectors"

export default connect(bulkActionsCustomFieldConnection, null)(BulkActionsCustomField)
